export const SHORT_NAME = 'short_name';
export const SHORT_NAME_ALT = 'shortName';
export const FULL_NAME = 'full_name';
export const THREE_LETTER_CODE = 'three_letter_code';
export const THREE_LETTER_CODE_ALT = 'threeLetterCode';
export const NAME = 'name';
